import { render } from "./ProducerLateDeliveryDirectModal.vue?vue&type=template&id=17670ff8"
import script from "./ProducerLateDeliveryDirectModal.vue?vue&type=script&lang=js"
export * from "./ProducerLateDeliveryDirectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__